import React, { useState, useRef, useEffect } from "react";
import { getInformations, getProperties } from '../../utils/databaseParser.js';
import { 
    ButtonDropdown, 
    ButtonRemoveRow, 
    IconDropdown, 
    LiDropdown, 
    InputAdvanced, 
    DivContainerDropdown, 
    DropdownMenu 
} from "./filterRow.styled";
import { getCurrentSearchOption } from '../../api/internal/usersInternalApi.js';

const COMPARATORS = [
    { label: 'est', value: 'equals' },
    { label: "n'est pas", value: 'not_equals' },
    { label: 'contient', value: 'contains' },
    { label: 'ne contient pas', value: 'not_contains' },
    { label: 'commence par', value: 'starts_with' },
    { label: 'finit par', value: 'ends_with' }
];

export function FilterRow({filterRow, setFilterRow, buttonAction}) {
    // States
    const [openDropdownOperator, setOpenDropdownOperator] = useState(false);
    const [openDropdownInformations, setOpenDropdownInformations] = useState(false);
    const [openDropdownProperties, setOpenDropdownProperties] = useState(false);
    const [openDropdownComparator, setOpenDropdownComparator] = useState(false);
    const [openDropdownInputs, setOpenDropdownInputs] = useState(false);
    
    const [dropdownOptionsValue, setDropdownOptionsValue] = useState(null);

    // Refs
    const dropdownRefs = {
        operator: useRef(),
        informations: useRef(),
        properties: useRef(),
        comparator: useRef(),
        inputs: useRef()
    };

    // Gestion de la suppression
    const removeRow = () => {
        let tempArray = [ 
            ...filterRow.slice(0, buttonAction.id - 1),
            ...filterRow.slice(buttonAction.id),
        ];
        // Réindexation propre des IDs
        tempArray = tempArray.map((item, index) => ({ ...item, id: index + 1 }));
        setFilterRow(tempArray);
    };

    const selectDropdownItem = (event) => {
        const { label, value } = event.target.dataset;
        
        if (label === 'information' && buttonAction.id === 1) {
            const tempArray = filterRow.map((item) => ({
                ...item, information: value, propertie: null, input: null
            }));
            setFilterRow(tempArray);
            return;
        }

        const tempArray = filterRow.map((item) => {
            if (item.id === buttonAction.id) {
                return { ...item, [label]: value };
            }
            return item;
        });
        setFilterRow(tempArray);
    };

    // Fermeture au clic extérieur (Sécurité)
    useEffect(() => {
        const closeDropdown = (e) => {
            if (dropdownRefs.operator.current && !dropdownRefs.operator.current.contains(e.target)) setOpenDropdownOperator(false);
            if (dropdownRefs.informations.current && !dropdownRefs.informations.current.contains(e.target)) setOpenDropdownInformations(false);
            if (dropdownRefs.properties.current && !dropdownRefs.properties.current.contains(e.target)) setOpenDropdownProperties(false);
            if (dropdownRefs.comparator.current && !dropdownRefs.comparator.current.contains(e.target)) setOpenDropdownComparator(false);
            if (dropdownRefs.inputs.current && !dropdownRefs.inputs.current.contains(e.target)) setOpenDropdownInputs(false);
        };
        document.addEventListener('click', closeDropdown);
        return () => document.removeEventListener('click', closeDropdown);
    }, []);

    const fetchCurrentSearchOption = async (model, property) => {
        setDropdownOptionsValue(await getCurrentSearchOption(model, property));
    };

    const handleInputChange = (e) => {
        const tempArray = filterRow.map(item => item.id === buttonAction.id ? { ...item, input: e.target.value} : item);
        setFilterRow(tempArray);
    };

    return (
        <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
            
            {/* 1. OPERATEUR */}
            <DivContainerDropdown ref={dropdownRefs.operator}>
                <ButtonDropdown 
                    width="70px" 
                    onClick={() => setOpenDropdownOperator(!openDropdownOperator)}
                    disabled={buttonAction.id === 1} 
                >
                    {buttonAction.id === 1 ? '...' : (buttonAction.operator || 'AND')}
                    {buttonAction.id !== 1 && <IconDropdown className={`bx bx-chevron-${openDropdownOperator ? 'up' : 'down'}`}/>}
                </ButtonDropdown>
                {/* Menu affiché uniquement si id > 1 */}
                {buttonAction.id !== 1 && (
                    <DropdownMenu className={openDropdownOperator ? 'active' : 'inactive'}>
                        <LiDropdown data-value="AND" data-label="operator" onClick={(e) => { selectDropdownItem(e); setOpenDropdownOperator(false); }}>AND</LiDropdown>
                        <LiDropdown data-value="OR" data-label="operator" onClick={(e) => { selectDropdownItem(e); setOpenDropdownOperator(false); }}>OR</LiDropdown>
                    </DropdownMenu>
                )}
            </DivContainerDropdown>

            {/* 2. INFORMATIONS (CORRECTION ICI) */}
            <DivContainerDropdown ref={dropdownRefs.informations}>
                <ButtonDropdown 
                    width="160px" 
                    // On n'ouvre le menu QUE si c'est la ligne 1
                    onClick={() => { if(buttonAction.id === 1) setOpenDropdownInformations(!openDropdownInformations) }}
                    // Visuellement désactivé pour les autres
                    disabled={buttonAction.id > 1}
                >
                    {buttonAction.information || 'Informations'}
                    {/* Chevron uniquement sur la ligne 1 */}
                    {buttonAction.id === 1 && <IconDropdown className={`bx bx-chevron-${openDropdownInformations ? 'up' : 'down'}`}/>}
                </ButtonDropdown>
                
                {/* Le menu déroulant n'est rendu QUE pour la ligne 1 */}
                {buttonAction.id === 1 && (
                    <DropdownMenu className={openDropdownInformations ? 'active' : 'inactive'}>
                        {getInformations().map(info => (
                            <LiDropdown 
                                key={info} 
                                data-value={info} 
                                data-label="information" 
                                onClick={(e) => { selectDropdownItem(e); setOpenDropdownInformations(false); }}
                            >
                                {info}
                            </LiDropdown>
                        ))}
                    </DropdownMenu>
                )}
            </DivContainerDropdown>

            {/* ... Le reste (Properties, Comparator, Inputs) reste identique ... */}
            
            {/* 3. PROPERTIES */}
             <DivContainerDropdown ref={dropdownRefs.properties}>
                <ButtonDropdown width="160px" onClick={() => setOpenDropdownProperties(!openDropdownProperties)}>
                    {buttonAction.propertie || 'Properties'}
                    <IconDropdown className={`bx bx-chevron-${openDropdownProperties ? 'up' : 'down'}`}/>
                </ButtonDropdown>
                <DropdownMenu className={openDropdownProperties ? 'active' : 'inactive'}>
                    {getProperties(buttonAction.information)?.map(prop => (
                        <LiDropdown 
                            key={prop} 
                            data-value={prop} 
                            data-label="propertie" 
                            onClick={(e) => { 
                                selectDropdownItem(e); 
                                fetchCurrentSearchOption(buttonAction.information, prop);
                                setOpenDropdownProperties(false); 
                            }}
                        >
                            {prop}
                        </LiDropdown>
                    ))}
                </DropdownMenu>
            </DivContainerDropdown>

             {/* 4. COMPARATEUR */}
            <DivContainerDropdown ref={dropdownRefs.comparator}>
                <ButtonDropdown width="140px" onClick={() => setOpenDropdownComparator(!openDropdownComparator)}>
                    {COMPARATORS.find(c => c.value === (buttonAction.comparator || 'contains'))?.label}
                    <IconDropdown className={`bx bx-chevron-${openDropdownComparator ? 'up' : 'down'}`}/>
                </ButtonDropdown>
                <DropdownMenu className={openDropdownComparator ? 'active' : 'inactive'}>
                    {COMPARATORS.map(comp => (
                        <LiDropdown key={comp.value} data-value={comp.value} data-label="comparator" onClick={(e) => { selectDropdownItem(e); setOpenDropdownComparator(false); }}>
                            {comp.label}
                        </LiDropdown>
                    ))}
                </DropdownMenu>
            </DivContainerDropdown>

            {/* 5. INPUT / VALUES */}
            {dropdownOptionsValue ? (
                <DivContainerDropdown ref={dropdownRefs.inputs}>
                    <ButtonDropdown width="300px" onClick={() => setOpenDropdownInputs(!openDropdownInputs)}>
                        {buttonAction.input || 'Inputs'}
                        <IconDropdown className={`bx bx-chevron-${openDropdownInputs ? 'up' : 'down'}`}/>
                    </ButtonDropdown>
                    <DropdownMenu className={openDropdownInputs ? 'active' : 'inactive'}>
                        {dropdownOptionsValue.map(val => (
                            <LiDropdown 
                                key={val} 
                                data-value={val} 
                                data-label="input" 
                                onClick={(e) => { selectDropdownItem(e); setOpenDropdownInputs(false); }}
                            >
                                {String(val)}
                            </LiDropdown>
                        ))}
                    </DropdownMenu>
                </DivContainerDropdown>
            ) : (
                <InputAdvanced 
                    placeholder="example : dsi@constellation.fr" 
                    value={buttonAction.input || ''} 
                    onChange={handleInputChange}
                />
            )}

            {/* BOUTON SUPPRIMER */}
            <ButtonRemoveRow 
                className={filterRow.length === 1 ? 'disabled' : ''} 
                onClick={(e) => { e.stopPropagation(); if (filterRow.length > 1) removeRow(); }}
            >
                -
            </ButtonRemoveRow>
        </div>
    )
}